/**
 * @generated SignedSource<<2b906695ae8346e4e585ad8878e54305>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorContentStateFragment_content$data = Result<{
  readonly contentState: {
    readonly color: string;
    readonly id: string | null;
    readonly isCallerPermitted: boolean | null;
    readonly lastModifierAaid?: string | null;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null;
  readonly contentStateLastUpdated?: {
    readonly value: string;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useEditorContentStateFragment_content";
}, unknown>;
export type useEditorContentStateFragment_content$key = {
  readonly " $data"?: useEditorContentStateFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorContentStateFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeApprovals"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeLastUpdated"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDraft"
    },
    {
      "defaultValue": "USER_FRIENDLY",
      "kind": "LocalArgument",
      "name": "lastUpdatedFormat"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorContentStateFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "args": [
        (v1/*: any*/)
      ],
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "contentState",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        },
        {
          "kind": "ScalarField",
          "name": "restrictionLevel"
        },
        {
          "kind": "ScalarField",
          "name": "isCallerPermitted"
        },
        {
          "condition": "includeApprovals",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lastModifierAaid"
            }
          ]
        }
      ]
    },
    {
      "condition": "includeLastUpdated",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "format",
              "variableName": "lastUpdatedFormat"
            },
            (v1/*: any*/)
          ],
          "concreteType": "ConfluenceDate",
          "kind": "LinkedField",
          "name": "contentStateLastUpdated",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "9357ed51da1e797003a0662f7fcbe2b8";

export default node;
